import {React, styled} from 'common'
import {useDeviceDetect} from 'services/hooks'

const RegisterComponentWrapper = ({sideImage, children}) => {
    const {isMobile} = useDeviceDetect()

    return (
        <Container>
            <FormContainer isMobile={isMobile}>{children}</FormContainer>
            {!isMobile && (
                <ImageContainer>
                    <Image src={sideImage} />
                </ImageContainer>
            )}
        </Container>
    )
}

export default RegisterComponentWrapper

const Container = styled('div')`
    display: flex;
    direction: rtl;
    flex: 1;
`

export const FormContainer = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    flex: 1;
    padding: ${({isMobile}) => (isMobile ? 10 : 48)}px;
`

const ImageContainer = styled('div')`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
    flex: 1;
`

const Image = styled('img')``
